import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/(main)/training/')({
    beforeLoad: () => {
        throw redirect({ to: '/training/announcement' });
    },
});
